/**
 * ADR-338 — the one digits rule for what the customer sees, the web side of the app's
 * customerDigits (mobile_app/lib/core/locale/customer_digits.dart). Arabic or Kurdish shows
 * Arabic-Indic digits with «٬» for thousands, «٫» for a decimal and «٪» after a number; English
 * shows Latin. Behind one switch, the theme setting eros_customer_indic_digits (off = Latin for
 * every language, today's look), read once per page so one page never shows both styles.
 * Cases: design/digits/digits_cases.json, which the app runs too. Display only.
 */
(function () {
  'use strict';

  function settingOn() {
    var s = window.themeVariables && window.themeVariables.settings;
    return !!(s && s.customerIndicDigits === true);
  }
  var pageIndic = settingOn();

  /** Whether a language code (or a tag like `ar`, `ckb`, `en-US`) shows Indic digits when on. */
  function indicLanguage(lang) {
    var l = String(lang == null ? '' : lang).toLowerCase();
    return l.indexOf('ar') === 0 || l.indexOf('ku') === 0 || l.indexOf('ckb') === 0;
  }

  function isDigit(c) {
    return (c >= 0x30 && c <= 0x39) || (c >= 0x0660 && c <= 0x0669) || (c >= 0x06f0 && c <= 0x06f9);
  }

  function toIndic(text) {
    var out = '';
    for (var i = 0; i < text.length; i++) {
      var c = text.charCodeAt(i);
      var prev = i > 0 && isDigit(text.charCodeAt(i - 1));
      var next = i + 1 < text.length && isDigit(text.charCodeAt(i + 1));
      if (c >= 0x30 && c <= 0x39) out += String.fromCharCode(0x0660 + c - 0x30);
      else if (c >= 0x06f0 && c <= 0x06f9) out += String.fromCharCode(0x0660 + c - 0x06f0);
      else if (c === 0x2c && prev && next) out += String.fromCharCode(0x066c);
      else if (c === 0x2e && prev && next) out += String.fromCharCode(0x066b);
      else if (c === 0x25 && prev) out += String.fromCharCode(0x066a);
      else out += text.charAt(i);
    }
    return out;
  }

  function toLatin(text) {
    var out = '';
    for (var i = 0; i < text.length; i++) {
      var c = text.charCodeAt(i);
      if (c >= 0x0660 && c <= 0x0669) out += String.fromCharCode(0x30 + c - 0x0660);
      else if (c >= 0x06f0 && c <= 0x06f9) out += String.fromCharCode(0x30 + c - 0x06f0);
      else if (c === 0x066c) out += ',';
      else if (c === 0x066b) out += '.';
      else if (c === 0x066a) out += '%';
      else out += text.charAt(i);
    }
    return out;
  }

  /** `text` in the customer's digits: Indic for ar/ku when on, Latin otherwise. Total and idempotent. */
  function customer(text, lang, indic) {
    var s = String(text == null ? '' : text);
    var on = typeof indic === 'boolean' ? indic : pageIndic;
    return on && indicLanguage(lang) ? toIndic(s) : toLatin(s);
  }

  window.ErosDigits = { customer: customer, indicLanguage: indicLanguage, enabled: function () { return pageIndic; } };
})();
